import { render, staticRenderFns } from "./MonitoringSystems.vue?vue&type=template&id=37a260c0&scoped=true"
import script from "./MonitoringSystems.vue?vue&type=script&lang=js"
export * from "./MonitoringSystems.vue?vue&type=script&lang=js"
import style0 from "./MonitoringSystems.vue?vue&type=style&index=0&id=37a260c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a260c0",
  null
  
)

export default component.exports